import Button from 'components/Button/Button';

export default Button;
